import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
function getHash(fallback) {
    return location.hash ? location.hash.substring(1) : fallback;
}
export function useTabs(fallback) {
    const defaultTab = getHash(fallback);
    const history = useHistory();
    const [tab, setTab] = useState(defaultTab);
    const onTabChange = useCallback((value) => {
        const { search } = history.location.state || {};
        history.push({
            state: search ? { search } : {},
            search: history.location.search,
            hash: value
        });
    }, []);
    if (tab !== defaultTab) {
        // to prevent re-routing of not having any effect
        setTab(defaultTab);
    }
    useEffect(() => {
        const handler = () => setTab(getHash(fallback));
        window.addEventListener("hashchange", handler);
        return () => {
            window.removeEventListener("hashchange", handler);
        };
    }, []);
    return [tab, onTabChange];
}
//# sourceMappingURL=useTabs.js.map